<h2 mat-dialog-title i18n>Report Spot '{{ data!.spot.name }}'</h2>
<mat-dialog-content>
  <p i18n>What would you like to report this spot for?</p>
  <mat-radio-group
    color="warn"
    class="d-flex flex-column"
    [(ngModel)]="data.reason"
  >
    <mat-radio-button value="duplicate" i18n=> Duplicate </mat-radio-button>

    <mat-radio-button value="torn down" i18n>Torn down</mat-radio-button>
    <mat-radio-button value="does not exist" i18n
      >Does not exist</mat-radio-button
    >
    <mat-radio-button value="private" i18n
      >It's a private spot and should not be on this spot map.</mat-radio-button
    >
    <mat-radio-button value="other" i18n>Other</mat-radio-button>
  </mat-radio-group>
  @if(data.reason === 'duplicate') {
  <p class="mat-body pt-3" i18n>Which spot is this spot a duplicate of?</p>
  <mat-form-field class="w-100">
    <mat-label i18n>Spot</mat-label>
    <input
      matInput
      placeholder="Spot name"
      [(ngModel)]="data.duplicateOf"
      required
    /> </mat-form-field
  >}
  <p class="mat-body pt-3" i18n>
    Note: Spot reports are public and will be displayed on the spot itself
    together with your profile and user name.
  </p>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-between p-3">
  <button mat-button (click)="onNoClick()" i18n="cancel button label">
    Cancel
  </button>
  <button
    [disabled]="!data.reason"
    mat-flat-button
    [mat-dialog-close]="data"
    color="warn"
    cdkFocusInitial
    (click)="submitReport()"
    i18n="report button label|"
  >
    Report
  </button>
</mat-dialog-actions>
